<ion-list>
    <div *ngFor="let s of sections; let i = index">
        <h3>{{sections[i].sectionName}}</h3>
        <ion-item>
            <ng-template #section="dynhost" dyn-host></ng-template>
        </ion-item>
    </div>
</ion-list>